module.exports = __webpack_public_path__ + "img/manufactured.7051a59a.svg";